import {
  Alert,
  AlertTitle,
  Box,
  Button,
  CircularProgress,
} from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { useAppDispatch, useAppSelector } from "../../Redux/hooks";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import http from "../../utils/http";
import { resetState } from "../../Redux/actions/resetAction";
import { errorToastMessage } from "../../utils/toast";

const AdminLockedAlert = () => {
  const { t } = useTranslation("responses");
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [loggingOut, setLoggingOut] = useState(false);
  const editable = useAppSelector((state) => state.response.editable);
  const isAdminAttempted = useAppSelector(
    (state) => state.response.isAdminAttempted,
  );
  const showAdminLockedMessage = !editable && isAdminAttempted;

  const handleLogoutToLanding = async () => {
    const studySlug = localStorage.getItem("study-slug") || "";
    try {
      setLoggingOut(true);
      await http.post("/participant/auth/logout");
    } catch (err) {
      errorToastMessage(err as Error);
    } finally {
      localStorage.clear();
      dispatch(resetState());
      navigate(studySlug ? `/study/${studySlug}` : "/auth/participant/login", {
        replace: true,
      });
    }
  };

  if (!showAdminLockedMessage) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      icon={<WarningAmberRoundedIcon fontSize="small" />}
      sx={{
        mb: 2,
        alignItems: "flex-start",
        border: "1px solid",
        borderColor: "warning.light",
        bgcolor: "rgba(255, 193, 7, 0.08)",
        color: "warning.dark",
        "& .MuiAlert-icon": {
          color: "warning.main",
          mt: 0.25,
        },
        "& .MuiAlert-message": {
          width: "100%",
        },
      }}
    >
      <AlertTitle sx={{ fontWeight: 600, mb: 0.5 }}>
        {t("SCREENING.ADMIN_LOCKED_ALERT_TITLE")}
      </AlertTitle>
      {t("SCREENING.ADMIN_LOCKED_ALERT_MESSAGE")}
      <Box sx={{ mt: 2 }}>
        <Button
          variant="contained"
          size="medium"
          onClick={handleLogoutToLanding}
          disabled={loggingOut}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            bgcolor: "warning.dark",
            color: "common.white",
            boxShadow: "none",
            "&:hover": {
              bgcolor: "warning.main",
              boxShadow: "none",
            },
          }}
        >
          {loggingOut ? (
            <CircularProgress size={20} sx={{ color: "common.white" }} />
          ) : (
            t("SCREENING.ADMIN_LOCKED_RETURN_BUTTON")
          )}
        </Button>
      </Box>
    </Alert>
  );
};

export default AdminLockedAlert;
